import React from 'react'
import { OtherDetails, } from '../../model/create_user';
import { Controller, SubmitHandler, useForm } from 'react-hook-form';
import { Autocomplete, Grid, TextField } from '@mui/material';
import { SchemeMaster } from '../../../schemes/models/scheme_master';
import StepFormActions from '../create_user_shared/step_form_actions';

interface props {
    onSubmit: (data: OtherDetails) => void;
    uid: number | null;
    setUid: (val: number) => void;
    stepperCount: number;
    setStepperCount: (val: number) => void;
    masterDataList: SchemeMaster;
    otherDetails: OtherDetails;
    modifyUser?: boolean | undefined;
    disableSaveBtn?: boolean;
    setDisableSaveBtn?: (val: boolean) => void
}

export default function OtherDetailsComp({
    stepperCount,
    onSubmit: _onSubmit,
    uid,
    setUid,
    setStepperCount,
    masterDataList,
    otherDetails,
    modifyUser,
    disableSaveBtn = false,
    setDisableSaveBtn
}
    : props) {
    const {
        register,
        control,
        handleSubmit,
        watch,
        formState: { errors },

    } = useForm<OtherDetails>({
        defaultValues: otherDetails,
    });

    const onSubmit: SubmitHandler<OtherDetails> = (data) => {
        setStepperCount(stepperCount + 1);
        _onSubmit(data);
    }

    return (
        <form onSubmit={handleSubmit(onSubmit)}>
            <Grid container mt={1} spacing={3}>
                <Grid item md={6} lg={6} sm={12} xs={12}>
                    <Controller
                        name="educational"
                        control={control}
                        render={({ field: { onChange, value } }) => (
                            <Autocomplete
                                fullWidth
                                value={value}
                                getOptionLabel={(option) => option.value}
                                renderInput={(params) => <TextField {...params} label="Educational Qualification (Optional)" />}
                                options={masterDataList?.education?.filter((item) => !item?.isAggregate) || []}
                                onChange={(_, selectedOption) => { onChange(selectedOption); setDisableSaveBtn?.(false) }}
                            />
                        )}
                    />
                </Grid>
                <Grid item md={6} lg={6} sm={12} xs={12}>
                    <Controller
                        name="workingStatus"
                        control={control}
                        render={({ field: { onChange, value } }) => (
                            <Autocomplete
                                fullWidth
                                value={value}
                                getOptionLabel={(option) => option.value}
                                renderInput={(params) => <TextField {...params} label="Working Status (Optional)" />}
                                options={masterDataList?.workingStatus?.filter((item) => !item?.isAggregate) || []}
                                onChange={(_, selectedOption) => { onChange(selectedOption); setDisableSaveBtn?.(false) }}
                            />
                        )}
                    />
                </Grid>
                <Grid item md={6} lg={6} sm={12} xs={12}>
                    <Controller
                        name="occupational"
                        control={control}
                        rules={{ required: "Occupation is required" }}
                        render={({ field: { onChange, value }, fieldState: { error } }) => (
                            <Autocomplete
                                fullWidth
                                value={value}
                                getOptionLabel={(option) => option.value}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        required
                                        label={<>Occupation <span style={{ color: "red" }}>*</span></>}
                                        error={!!error}
                                        helperText={error?.message}
                                    />
                                )}
                                options={masterDataList?.occupation?.filter((item) => !item?.isAggregate) || []}
                                onChange={(_, selectedOption) => {
                                    onChange(selectedOption);
                                    setDisableSaveBtn?.(false)
                                }}
                            />
                        )}
                    />
                </Grid>
                <Grid item md={6} lg={6} sm={12} xs={12}>
                    <Controller
                        name="familyType"
                        control={control}
                        render={({ field: { onChange, value } }) => (
                            <Autocomplete
                                fullWidth
                                value={value}
                                getOptionLabel={(option) => option.value}
                                renderInput={(params) => <TextField {...params} label="Family Type (Optional)" />}
                                options={masterDataList?.familyType?.filter((item) => !item?.isAggregate) || []}
                                onChange={(_, selectedOption) => {
                                    onChange(selectedOption);
                                    setDisableSaveBtn?.(false)
                                }}
                            />
                        )}
                    />
                </Grid>
                <Grid item md={6} lg={6} sm={12} xs={12}>
                    <Controller
                        name="ownershipOfHouse"
                        control={control}
                        render={({ field: { onChange, value } }) => (
                            <Autocomplete
                                fullWidth
                                value={value}
                                getOptionLabel={(option) => option.value}
                                renderInput={(params) => <TextField {...params} label="Ownership of House (Optional)" />}
                                options={masterDataList?.houseOwnership?.filter((item) => !item?.isAggregate) || []}
                                onChange={(_, selectedOption) => {
                                    onChange(selectedOption);
                                    setDisableSaveBtn?.(false)
                                }}
                            />
                        )}
                    />
                </Grid>
                <Grid item md={6} lg={6} sm={12} xs={12}>
                    <Controller
                        name="personalIncome"
                        control={control}
                        render={({ field: { onChange, value } }) => (
                            <Autocomplete
                                fullWidth
                                value={value}
                                getOptionLabel={(option) => option.value}
                                renderInput={(params) => <TextField {...params} label="Personal Income (Optional)" />}
                                options={masterDataList?.personalIncome?.filter((item) => !item?.isAggregate) || []}
                                onChange={(_, selectedOption) => {
                                    onChange(selectedOption);
                                    setDisableSaveBtn?.(false)
                                }}
                            />
                        )}
                    />
                </Grid>
                <Grid item md={6} lg={6} sm={12} xs={12}>
                    <Controller
                        name="familyIncome"
                        control={control}
                        render={({ field: { onChange, value } }) => (
                            <Autocomplete
                                fullWidth
                                value={value}
                                getOptionLabel={(option) => option.value}
                                renderInput={(params) => <TextField {...params} label="Family Income (Optional)" />}
                                options={masterDataList?.familyIncome?.filter((item) => !item?.isAggregate) || []}
                                onChange={(_, selectedOption) => {
                                    onChange(selectedOption);
                                    setDisableSaveBtn?.(false)
                                }}
                            />
                        )}
                    />
                </Grid>
                <Grid item md={12} lg={12} sm={12} xs={12}>
                    <StepFormActions
                        showBack={!modifyUser}
                        onBack={() => setStepperCount(stepperCount - 1)}
                        disabled={disableSaveBtn}
                        submitLabel={!modifyUser ? "Proceed" : "Save Changes"}
                    />
                </Grid>
            </Grid>
        </form>
    )
}
